export default (attrKeys, relKeys, namespaceValues) => {
  namespaceValues ??= [];
  attrKeys ??= [];
  relKeys ??= [];

  const keyList = attrKeys
    .map(key => ({
      caption: key,
      key,
      meta: "attribute key"
    }))
    .concat(
      relKeys.map(key => ({
        caption: key,
        key,
        meta: "relation key"
      }))
    )
    .concat(
      namespaceValues.map(val => ({
        caption: val,
        key: val,
        meta: "namespace value"
      }))
    )
    .concat(queryKeyList);

  return {
    getCompletions(editor, session, pos, prefix, callback) {
      return callback(
        null,
        keyList.map(({ key, caption, meta }) => ({
          caption: key,
          value: key,
          meta
        }))
      );
    }
  };
};

var queryKeyList = [
  {
    key: "restrict ",
    meta: "restrictor",
    caption: "Only include elements with the following ids."
  },
  {
    key: "equalTo ",
    meta: "restrictor",
    caption: "Only include elements with the exact attribute value."
  },
  {
    key: "createdBy ",
    meta: "restrictor",
    caption: "Only include elements created by the following user."
  },
  {
    key: "selectRelations ",
    meta: "loader",
    caption: "Fully load the following relations."
  },
  {
    key: "selectOut ",
    meta: "loader",
    caption: "Fully load the following outgoing relations."
  },
  {
    key: "selectOutMinus ",
    meta: "loader",
    caption: "Don't load the following outgoing relations."
  },
  {
    key: "selectIn ",
    meta: "loader",
    caption: "Fully load the following incoming relations."
  },
  {
    key: "selectInMinus ",
    meta: "loader",
    caption: "Don't load the following incoming relations."
  },
  {
    key: "selectRecursiveOut ",
    meta: "loader",
    caption: "Recursively load the following outgoing relations."
  },
  {
    key: "selectRecursiveIn ",
    meta: "loader",
    caption: "Recursively load the following incoming relations."
  },
  {
    key: "alwaysLoadRelations ",
    meta: "loader",
    caption: "Load all relation nodes in the results."
  },
  {
    key: "noRelations ",
    meta: "loader",
    caption: "Don't include any relations in the results."
  },
  {
    key: "noAttributes ",
    meta: "loader",
    caption: "Don't include any attributes in the results"
  },
  {
    key: "limit ",
    meta: "restrictor",
    caption: "Maximum number of results to include."
  },
  {
    key: "skip ",
    meta: "restrictor",
    caption: "Skip the first `n` results."
  },
  {
    key: "order ",
    meta: "sorter",
    caption: "Order results by attribute value."
  },
  {
    key: "ascending ",
    meta: "sorter",
    caption: "Order results by attribute value ascending."
  },
  {
    key: "inGraph ",
    meta: "restrictor",
    caption: "Only include results in the following graph."
  },
  {
    key: "notInGraph ",
    meta: "restrictor",
    caption: "Only include results not in the following graph."
  },
  {
    key: "hasNoLabel ",
    meta: "restrictor",
    caption: "Only include results which do not have a label."
  },
  {
    key: "hasLabel ",
    meta: "restrictor",
    caption: "Only include results which have a label."
  },
  {
    key: "hasNoRecursiveRelationIn ",
    meta: "restrictor",
    caption: "Does not have the following recursive incoming relation"
  },
  {
    key: "hasNoRecursiveRelationOut ",
    meta: "restrictor",
    caption: "Does not have the following recursive outgoing relation"
  },
  {
    key: "hasRecursiveRelationIn ",
    meta: "restrictor",
    caption: "Has the following recursive incoming relation"
  },
  {
    key: "hasRecursiveRelationOut ",
    meta: "restrictor",
    caption: "Has the following recursive outgoing relation"
  },
  {
    key: "startsWith ",
    meta: "restrictor",
    caption: "Attribute value starts with the following"
  },
  {
    key: "endsWith ",
    meta: "restrictor",
    caption: "Attribute value ends with the following"
  },
  {
    key: "equalToIgnoreCase ",
    meta: "restrictor",
    caption: "Attribute value is equal to the following, ignoring case"
  },
  {
    key: "notEqualTo ",
    meta: "restrictor",
    caption: "Attribute value is not equal to the following"
  },
  {
    key: "lessThan ",
    meta: "restrictor",
    caption: "Attribute value is less than the following"
  },
  {
    key: "greaterThan ",
    meta: "restrictor",
    caption: "Attribute value is greater than the following"
  },
  {
    key: "lessThanOrEqualTo ",
    meta: "restrictor",
    caption: "Attribute value is less than or equal to the following"
  },
  {
    key: "greaterThanOrEqualTo ",
    meta: "restrictor",
    caption: "Attribute value is greater than or equal to the following"
  },
  {
    key: "hasRelationIn ",
    meta: "restrictor",
    caption: "Results must have the following incoming relation"
  },
  {
    key: "hasRelationOut ",
    meta: "restrictor",
    caption: "Results must have the following outgoing relation"
  },
  {
    key: "hasNoRelationIn ",
    meta: "restrictor",
    caption: "Results must not have the following incoming relation"
  },
  {
    key: "hasNoRelationOut ",
    meta: "restrictor",
    caption: "Results must not have the following outgoing relation"
  }
];
